import { render, staticRenderFns } from "./checklistRiskRegister.vue?vue&type=template&id=d2cfbe14"
import script from "./checklistRiskRegister.vue?vue&type=script&lang=js"
export * from "./checklistRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2cfbe14')) {
      api.createRecord('d2cfbe14', component.options)
    } else {
      api.reload('d2cfbe14', component.options)
    }
    module.hot.accept("./checklistRiskRegister.vue?vue&type=template&id=d2cfbe14", function () {
      api.rerender('d2cfbe14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/checklist/risk/checklistRiskRegister.vue"
export default component.exports